import React, { useEffect, useState } from 'react';
import { Card, Spinner, ErrBox } from '../../../components/UI';
import { contractAPI } from '../../../utils/api';
import { fmtRp } from '../../../utils/format';

const statusColor = {
  AKTIF: { bg: '#DCFCE7', color: '#166534' },
  DALAM_PELAKSANAAN: { bg: '#DBEAFE', color: '#1E40AF' },
  DRAFT: { bg: '#F3F4F6', color: '#374151' },
  SELESAI: { bg: '#ECFDF5', color: '#059669' },
  EXPIRED: { bg: '#FEE2E2', color: '#991B1B' },
  DIBATALKAN: { bg: '#FEF2F2', color: '#DC2626' },
};

export default function KontrakDashboardTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    contractAPI.getDashboard()
      .then(r => setData(r.data))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;
  if (error) return <ErrBox msg={error} />;
  if (!data) return null;

  const { total_contracts, total_nilai, total_terpakai, by_status, near_expiry } = data;
  const sisa_nilai = total_nilai - (total_terpakai || 0);

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
        <Card style={{ borderLeft: '4px solid #7C3AED', padding: '16px 20px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 12, fontWeight: 600, color: '#6B7280' }}>TOTAL KONTRAK</p>
          <p style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#111827' }}>{total_contracts}</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #059669', padding: '16px 20px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 12, fontWeight: 600, color: '#6B7280' }}>NILAI KONTRAK</p>
          <p style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#111827' }}>{fmtRp(total_nilai)}</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #D97706', padding: '16px 20px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 12, fontWeight: 600, color: '#6B7280' }}>SISA NILAI</p>
          <p style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#111827' }}>{fmtRp(sisa_nilai)}</p>
        </Card>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Card style={{ padding: '16px 20px' }}>
          <h4 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: 600 }}>Per Status</h4>
          {by_status.length === 0 && <p style={{ color: '#9CA3AF', fontSize: 13 }}>Belum ada data</p>}
          {by_status.map(s => {
            const c = statusColor[s.status_kontrak] || { bg: '#F3F4F6', color: '#374151' };
            return (
              <div key={s.status_kontrak} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #F3F4F6' }}>
                <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: c.bg, color: c.color }}>
                  {s.status_kontrak}
                </span>
                <div style={{ textAlign: 'right' }}>
                  <span style={{ fontWeight: 600, fontSize: 13 }}>{s.count} kontrak</span>
                  <br /><span style={{ fontSize: 12, color: '#6B7280' }}>{fmtRp(Number(s.nilai) || 0)}</span>
                </div>
              </div>
            );
          })}
        </Card>

        <Card style={{ padding: '16px 20px' }}>
          <h4 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: 600 }}>Akan Berakhir (30 Hari)</h4>
          {near_expiry.length === 0 && <p style={{ color: '#9CA3AF', fontSize: 13 }}>Tidak ada kontrak yang akan berakhir</p>}
          {near_expiry.map(c => (
            <div key={c.id} style={{ padding: '10px 0', borderBottom: '1px solid #F3F4F6' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 600, fontSize: 13 }}>{c.contract_no}</span>
                <span style={{ fontSize: 12, color: '#6B7280' }}>{new Date(c.tanggal_selesai).toLocaleDateString('id-ID')}</span>
              </div>
              <p style={{ margin: '2px 0 0', fontSize: 12, color: '#374151' }}>{c.judul}</p>
              <p style={{ margin: 0, fontSize: 12, color: '#9CA3AF' }}>{c.vendor_nama}</p>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
